import { render, staticRenderFns } from "./GuanjiaAdd.vue?vue&type=template&id=6de56908&scoped=true"
import script from "./GuanjiaAdd.vue?vue&type=script&lang=js"
export * from "./GuanjiaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de56908",
  null
  
)

export default component.exports